// extracted by mini-css-extract-plugin
module.exports = {"allRightReserved":"styles_allRightReserved__2D_fU"};